import { PayloadAction, createSlice } from '@reduxjs/toolkit'
// import { ISchwabUserPrincipals } from '../interfaces/ISchwabUserPrincipals'
import IOption from '../interfaces/IOption'
import { IQuote } from '../interfaces/IQuote'

export interface SchwabState {
  userPrincipals: null
  webSocketConnected: boolean
  requestId: number
  schwabOptions: IOption[]
  schwabQuotes: IQuote[]
}

export const schwabInitialState: SchwabState = {
  userPrincipals: null,
  webSocketConnected: false,
  requestId: 0,
  schwabOptions: [],
  schwabQuotes: []
}

export const schwabSlice = createSlice({
  name: 'schwab',
  initialState: schwabInitialState,
  reducers: {
    setUserPrincipals: (state, action: PayloadAction<null>) => {
      state.userPrincipals = action.payload
    },
    setSchwabWebSocketConnected: (state, action: PayloadAction<boolean>) => {
      state.webSocketConnected = action.payload
    },
    incrementRequestId: (state) => {
      // increment by two because we always do a quote and an option subscription together (unsubscribe together as well)
      state.requestId += 2
    },
    setSchwabOptions: (state, action: PayloadAction<IOption[]>) => {
      state.schwabOptions = action.payload
    },
    setSchwabQuotes: (state, action: PayloadAction<IQuote[]>) => {
      state.schwabQuotes = action.payload
    }
  }
})

export const { setUserPrincipals, setSchwabWebSocketConnected, incrementRequestId, setSchwabOptions, setSchwabQuotes } =
  schwabSlice.actions

export default schwabSlice.reducer
